import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export var applyGoodsRoute = [{
  path: "apply-goods",
  name: "applyGoods",
  component: function component() {
    return import( /* webpackChunkName: "login" */"./apply-goods.vue");
  }
}];